import React from 'react';
interface ColumviLogoProps {
  size?: 'sm' | 'md' | 'lg';
  variant?: 'light' | 'dark';
}
export function ColumviLogo({
  size = 'md',
  variant = 'light'
}: ColumviLogoProps) {
  // Using the uploaded logo image
  const logoUrl = 'https://cdn.magicpatterns.com/uploads/hAB8acDEdGBVgviFbRBc8U/COLUMVI_R_GL_Logo_RGB.png';
  // Increased sizes and added white background container
  const heightMap = {
    sm: 'h-10',
    md: 'h-14',
    lg: 'h-16' // Was h-12
  };
  return <div className="bg-white/95 backdrop-blur-sm px-3 py-1.5 rounded-lg shadow-sm inline-block" data-id="element-49">
      <img src={logoUrl} alt="Columvi Logo" className={`${heightMap[size]} w-auto object-contain`} data-id="element-50" />
    </div>;
}